class CountdownTimer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const options = JSON.parse(this.dataset.options);
    console.log(options);
    this._startCountdown(options);
  }

  disconnectedCallback() {
  }

  _startCountdown(options) {
    let time = options.general_time;
    if(options.customer_tags.includes(options.vip_tag)) {
      time = options.vip_time;
    } else if(options.customer_tags.includes(options.a_tag)) {
      time = options.a_time;
    }
    const countdown = new Countdown(time, this, options.collection_handle, options);
    countdown.start();
  }
}

class Countdown  {
  constructor(time, element, collectionHandle, options = {}) {
    this.time = time;
    this.element = element;
    this.collectionHandle = collectionHandle;
    this.options = options;
  }
  start(leadTime = 0) {
    let endDate = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Chicago' }));
    endDate.setDate(endDate.getDate() + leadTime);
    endDate.setHours(this.time.split(':')[0], this.time.split(':')[1], 0, 0);
    const endTime = endDate;
    this._interval = setInterval(() => {
      const now = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Chicago' }));
      const nowTime = now
      const timeToComplete = endTime - nowTime;
      let timerComplete = false;
      let days = Math.floor(timeToComplete / (1000 * 60 * 60 * 24));
      let hours = this._formatNumber(Math.floor((timeToComplete % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)));
      let minutes = this._formatNumber(Math.floor((timeToComplete % (1000 * 60 * 60)) / (1000 * 60)));
      let seconds = this._formatNumber(Math.floor((timeToComplete % (1000 * 60)) / 1000));
      if(leadTime > 0) {
         let adjustedSeconds = this._formatNumber(Math.floor(timeToComplete / 1000));
         let adjustedMinutes = this._formatNumber(Math.abs(Math.floor(adjustedSeconds / 60)));
         hours = this._formatNumber(Math.abs(Math.floor(adjustedMinutes / 60)));
      }
      if(timeToComplete < 0) {
        timerComplete = true
      }
      this._updateElement(days, hours, minutes, seconds, timerComplete);
    }, 1000);
  }
  _formatNumber(number) {
    return number.toString().padStart(2, '0');
  }
  _updateElement(days, hours, minutes, seconds, timerComplete) {
    
    if (timerComplete) {
      if (Object.prototype.hasOwnProperty.call(this.options, 'suggestions_container_id')) {
        document.querySelector(`#${this.options.container_id}`).classList.add('countdown-timer-completed', 'loaded');
        document.querySelector(`#${this.options.suggestions_container_id}`).classList.add('countdown-timer-completed', 'loaded');
        resetHeight(`#${this.options.suggestions_container_id} .personalised-suggestions__list`, `.product-tile__container`).then(() => {
          matchHeight(`#${this.options.suggestions_container_id} .personalised-suggestions__list`, `.product-tile__container`).then(() => {
            console.log("daily drop personalised-suggestions__list");
          });
        });
        this._stop();
      } else {
        if (document.querySelector(`[data-collection-grid="${this.collectionHandle}"]`)) {
          document.querySelector(`[data-collection-grid="${this.collectionHandle}"]`).classList.add('countdown-timer-completed', 'loaded');
        }
        resetHeight(`[data-collection-grid="${this.collectionHandle}"]`, `.product-tile__container`).then(() => {
          matchHeight(`[data-collection-grid="${this.collectionHandle}"]`, `.product-tile__container`).then(() => {
            console.log("daily drop personalised-suggestions__list");
          });
        });
        this._stop();
        const today = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Chicago' })).getDay();
        if (today === 0) {
          this.start(1);
        }
        else if (today === 6) {
          this.start(2);
        }
        else if (today === 5) {
          this.start(3);
        }
        else {
          this.start(1);
        }
      }
    } else {
      this.element.innerHTML = `
        <div class="countdown-timer-item-value">
          <span class="countdown-timer-item-value-time">${hours}</span>
          <span>HOURS</span>
        </div>
        <div class="countdown-timer-item-separator">
        <span>:</span>
        </div>
        <div class="countdown-timer-item-value">  
        <span class="countdown-timer-item-value-time">${minutes}</span>
          <span>MINUTES</span>
        </div>
      `;
      if(Object.prototype.hasOwnProperty.call(this.options, 'container_id')) {
        document.querySelector(`#${this.options.container_id}`).classList.add('loaded');
      } else {
        document.querySelector(`.countdown-timer-section`).classList.add("loaded");
      }
    }
  }
  _stop() {
    clearInterval(this._interval);
  }
}

customElements.define('countdown-timer', CountdownTimer);